import { useScopedAppFlagStore } from '@frontend/scope';
import { MarketingAttributionsFeatureFlags } from '../feature-flags';
import { useCheckMarketingAttributionDemoAccount } from './use-check-marketing-attribution-demo-account';

export const useShowMarketingAttributionAnalyticsNav = () => {
  const isDemoAccount = useCheckMarketingAttributionDemoAccount();

  const { getFeatureFlagValue } = useScopedAppFlagStore();

  const marketingAttributionFeatureEnabled = getFeatureFlagValue(MarketingAttributionsFeatureFlags.enabled);

  return marketingAttributionFeatureEnabled || isDemoAccount;
};
